import { render } from "./EmployeeMediaObject.vue?vue&type=template&id=1c22d902"
import script from "./EmployeeMediaObject.vue?vue&type=script&lang=js"
export * from "./EmployeeMediaObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__